var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"quoter-result-table"},_vm._l((_vm.quoteTableData),function(quoteItem){return _c('tr',{key:quoteItem.fieldName},[_c('td',[_vm._v(_vm._s(quoteItem.fieldName))]),_c('td',[_vm._v(_vm._s(quoteItem.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }